import { SMART_CONTRACT_TYPES, SMART_CONTRACT_PLUGIN_IDS } from "@/components/SmartContractDesigner/smartContractPluginIDs";

export const recursivelyCreateNodes = (finalNodes, plugins, connectors, nodes, currentConnectors, prevRef) => {
    currentConnectors.map(connectorUuid => {
        const connectorInstance = connectors.find(connector => connector.uuid === connectorUuid);
        const goingToPlugin = plugins.find(plugin => plugin.uuid === connectorInstance.to);
        const node = nodes.find(node => node.id === connectorInstance.to);
        return {
            connectorInstance,
            goingToPlugin,
            node
        };
    }).forEach(connection => {
        if (connection.goingToPlugin.id === SMART_CONTRACT_TYPES.SMART_CONTRACT_DELIMITATOR) {
            if (prevRef) {
                const connector = connectors.find(conn => conn.uuid === connection.goingToPlugin.outgoing[0]);
                const refToReturnTo = prevRef[prevRef.length - 1];
                let futurePrevRef = prevRef.filter(elem => elem !== refToReturnTo);
                futurePrevRef = futurePrevRef && futurePrevRef.length === 0 ? null : futurePrevRef;
                recursivelyCreateNodes(refToReturnTo, plugins, connectors, nodes, [connector.uuid], futurePrevRef);
            }
            return;
        }
        let lastIndex;
        connection.node.index = finalNodes.length;
        if (connection.goingToPlugin.id === SMART_CONTRACT_PLUGIN_IDS.GENERAL_END_PLUGIN || connection.goingToPlugin.id === "GENERAL_END_PLUGIN") {
            return finalNodes;
        }
        lastIndex = finalNodes.push(connection.node) - 1;

        if ((connection.node.trueList || connection.node.forList) && connection.goingToPlugin.id !== SMART_CONTRACT_TYPES.SMART_CONTRACT_DELIMITATOR) {
            if (!prevRef) prevRef = [finalNodes];
            else prevRef.push(finalNodes);
            if (connection.goingToPlugin.id === SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_IF && connection.goingToPlugin.outgoing.length > 1) {
                // TODO: check direction of the connecting line
                recursivelyCreateNodes(finalNodes[lastIndex].trueList, plugins, connectors, nodes, [connection.goingToPlugin.outgoing[0]], prevRef);
                recursivelyCreateNodes(finalNodes[lastIndex].falseList, plugins, connectors, nodes, [connection.goingToPlugin.outgoing[1]]);
            } else if (connection.goingToPlugin.id === SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_FOR) {
                // TODO: check direction of the connecting line
                recursivelyCreateNodes(finalNodes[lastIndex].forList, plugins, connectors, nodes, [connection.goingToPlugin.outgoing[0]], prevRef);
            } else {
                recursivelyCreateNodes(finalNodes[lastIndex].trueList, plugins, connectors, nodes, connection.goingToPlugin.outgoing, prevRef);
            }
        } else if (connection.goingToPlugin.id !== SMART_CONTRACT_PLUGIN_IDS.GENERAL_END_PLUGIN) {
            recursivelyCreateNodes(finalNodes, plugins, connectors, nodes, connection.goingToPlugin.outgoing, prevRef);
        }
    });
    return finalNodes;
};

export const flattenFunctionBody = (nodes, final) => {
    if (!final) final = [];
    if (nodes) {
        final.push(...nodes.map(node => {
            const copy = { ...node };
            if (copy.trueList) copy.trueList = [];
            if (copy.falseList) copy.falseList = [];
            if (copy.forList) copy.forList = [];
            return copy;
        }));
    }
    for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].trueList) {
            flattenFunctionBody(nodes[i].trueList, final);
            if (nodes[i].falseList) {
                flattenFunctionBody(nodes[i].falseList, final);
            }
        }
        if (nodes[i].forList) {
            flattenFunctionBody(nodes[i].forList, final);
        }
    }
    return final;
};

export const getObjectDiagramData = (func) => {
    if (typeof func.diagramData === "string") {
        while (typeof func.diagramData === "string") {
            func.diagramData = JSON.parse(func.diagramData);
        }
    }
    return func;
};
